export enum CodeErrors {
  UNAUTHORIZED = 'Ref: Unauthorized error',
  FORBIDDEN = 'Ref: Forbidden',
  NOT_FOUND = 'Ref: Not found',
  GENERIC_ERROR = 'Ref: Generic error',
}
